import React, {useEffect} from "react"

import {FormattedMessage, useIntl} from "@irati/utils/lang"
import {Row} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"
import {Label} from "@irati/ui/src/Typography"
import {Select} from "@irati/ui/src/FormItem"
import {RouterLink} from "@irati/ui/src/Link"
import Validation from "@irati/utils/validation"

import {WalletRoutes} from "../../../enums/Routes"
import {useBudgetsList, useBudgetsPermissions} from "@irati/wallet/hooks/budget"
import {useRewardsDistribution, useRewardsDistributionActions} from "../../../stores/DistributeReward/hooks"

const selectCategorySchema = () => {
  return Validation.string("platform.defaultValidation.required")
}

const BudgetCategory = () => {
  const {canBudget, isBudgetAdmin} = useBudgetsPermissions()
  const intl = useIntl()
  const {data} = useBudgetsList()
  const payload = useRewardsDistribution()
  const {dispatch} = useRewardsDistributionActions()

  const options = []
  options.push({
    value: data?.budgets.unassigned.name,
    label: `${intl.formatNumber(data?.budgets.unassigned.amount! / 100)} - ${data?.budgets.unassigned.name}`
  })
  data?.budgets.categories.map(({name, amount}) => options.push({value: name, label: `${intl.formatNumber(amount / 100)} - ${name}`}))

  useEffect(() => {
    if (data?.hasNoBudgets) {
      dispatch({
        type: "SET_BUDGET_CATEGORY",
        payload: {
          budgetCategory: data.budgets.unassigned.name
        }
      })
    }
  }, [data, dispatch])

  const handleSelectCategory = (budgetCategory: string) => {
    dispatch({
      type: "SET_BUDGET_CATEGORY",
      payload: {
        budgetCategory
      }
    })
  }

  if (!canBudget) {
    return null
  }

  return (
    <Flex direction="column" paddingLeft={3} paddingRight={3}>
      <Flex alignItems="center" justifyContent="space-between">
        <Label large>
          <FormattedMessage id="wallet.reward.budget.distribute.category.title" />
        </Label>
        {isBudgetAdmin && (
          <RouterLink cta to={WalletRoutes.FLEXI_BUDGET}>
            <FormattedMessage id="wallet.reward.budget.distribute.category.cta.editCategories" />
          </RouterLink>
        )}
      </Flex>
      <Row>
        <Select
          id="selectCategory"
          isClearable={false}
          isDisabled={data?.hasNoBudgets}
          value={payload.budgetCategory}
          options={options}
          name="selectCategory"
          placeholder="wallet.reward.budget.distribute.category.placeholder"
          aria-label="Select Budget Category"
          onChange={handleSelectCategory}
          validation={selectCategorySchema()}
        />
      </Row>
    </Flex>
  )
}

export default BudgetCategory
